import React, { useState } from "react";
import "./authenticate.css";
import UserLoginImage from "../assets/userLogin_image.svg";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function UserLogin() {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setemail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLoginSubmit = async (event) => {
    event.preventDefault();

    const data = { email };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/user/api/login`, // Change to your login route
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data.token) {
        // Save token to localStorage
        localStorage.setItem("userId", response.data.token);
        alert("Login Successful");

        // Optional: log token
        console.log("Stored Token:", response.data.token);

        // Redirect to dashboard
        navigate("/userDashboard");
      } else {
        setErrorMessage(response.data.message || "Login failed. Try again.");
      }
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message || "An error occurred. Please try again."
      );
    }
  };

  return (
    <div className="userLogin container">
      <div className="loginArea d-flex flex-column flex-lg-row col-12">
        <div className="form w-100 w-lg-50 p-4">
          <div className="introText mb-4">
            <h1>Hello User!</h1>
            <p>Login now to Check your Status.</p>
          </div>
          <form onSubmit={handleLoginSubmit}>
            <div className="d-flex flex-column mb-3">
              <input
                type="email"
                placeholder="Your email here"
                className="form-control"
                required
                value={email}
                onChange={(e) => setemail(e.target.value)}
              />
            </div>

            {errorMessage && (
              <div className="alert alert-danger">{errorMessage}</div>
            )}

            <div className="submit">
              <button type="submit" className="btn btn-primary w-100">
                Login
              </button>
            </div>
          </form>
        </div>

        {/* Image Section */}
        <div className="introImage w-100 w-lg-50">
          <img
            src={UserLoginImage}
            alt="Parking area"
            className="img-fluid"
          />
        </div>
      </div>
    </div>
  );
}

export default UserLogin;
